import { SET_LOADING } from "./actionTypes";

export const setLoading = (name: string, value: boolean) => {
  return { type: SET_LOADING, payload: value, name };
};
